import { colors } from '../../colors';
var card = {
  textColorDark: colors.metal,
  textColorLight: colors.white,
  bgColor: colors.powder,
  bgColorHero: colors.powder
};
export default card;